module.exports = __webpack_public_path__ + "static/media/Filter_Criteria_English.d554c939.svg";